import { Svg } from 'components/svg'
import { IconType } from 'models'

export const IconArrow: IconType = ({ className = '' }) => (
  <Svg
    viewBox="0 0 26 33"
    className={className}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.1149 0.294921L11.1149 25.2675L3.02013 17.5201L0.357228 20.073L13.0009 32.1792L25.6445 20.073L22.9782 17.5201L14.8868 25.2675L14.8868 0.294922L11.1149 0.294921Z"
      fill="currentColor"
    />
  </Svg>
)
